<div class="page-display" *ngIf="page" [innerHTML]="page.content"></div>
